import { AfterViewInit, Component, DestroyRef, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { FacultyMenuComponent } from '../../shared/faculty-menu/faculty-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { SheetRow, SheetTableService } from '../services/sheet-table.service';


@Component({
  selector: 'app-publications',
  standalone: true,
  imports: [CommonModule, MainMenuComponent, FacultyMenuComponent, SubscribeComponent],
  templateUrl: '../templates/publications.component.html',
  styleUrls: ['../css/sheet-table.css']
})
export class PublicationsComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRTSln4yEpcrpy0Y_nnJAMtorf57WhP7CnUe05Di9-3Ow-GPdxQa7i6fHSKhlKqg8AkneDgD0q7gIOf/pub?gid=0&single=true&output=csv';

  readonly rows = signal<SheetRow[]>([]);
  readonly columns = signal<string[]>([]);
  readonly isLoading = signal(true);
  readonly errorMessage = signal('');

  constructor(
    private readonly scriptLoader: ScriptLoaderService,
    private readonly sheetTableService: SheetTableService
  ) { }

  ngOnInit(): void {
    this.sheetTableService
      .loadTableFromCsvUrl(this.csvUrl)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (tableData) => {
          this.rows.set(tableData.rows);
          this.columns.set(tableData.columns);
          this.isLoading.set(false);
        },
        error: () => {
          this.errorMessage.set('Unable to load publications data right now.');
          this.isLoading.set(false);
        }
      });
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }
}


